export const EventSeverity = {
    Debug: 0,
    Trace: 1,
    Information: 2,
    UserError: 3,
    SystemError: 4,
    Critical: 5
}